/** A position in Google's world pixels at the current zoom (Projection.fromLatLngToPoint × 2^zoom). */
export type WorldPoint = { x: number; y: number };

/** Pins closer than about this many screen pixels share a cluster. */
export const CLUSTER_CELL_PX = 72;

/**
 * DD-3696: groups pins that would overlap on screen. Grid clustering: each pin falls in a
 * CLUSTER_CELL_PX square of world pixels, and a square's pins form one group. Returns the
 * pins' indexes per group, groups in order of their first pin.
 */
export const clusterWorldPoints = (points: WorldPoint[], cellPx = CLUSTER_CELL_PX): number[][] => {
    const groups = new Map<string, number[]>();
    points.forEach((point, index) => {
        const cell = `${Math.floor(point.x / cellPx)}:${Math.floor(point.y / cellPx)}`;
        const group = groups.get(cell);
        if (group) group.push(index);
        else groups.set(cell, [index]);
    });
    return Array.from(groups.values());
};
